import React, { useEffect, useState } from "react";
import { Input } from "../Simple";

export default function ValidatedInput(props) {
    const [validation, setValidation] = useState(null);

    useEffect(() => {
        if (props.onValidate) {
            setValidation(props.onValidate(props.value));
        }
    }, [props.value, props.onValidate]);

    const getClassByValidationLevel = () => {
        return validation.level === 'information' ? 'text-primary' :
            validation.level === 'warning' ? 'text-warning' :
            validation.level === 'error' ? 'text-danger' :
            undefined;
    }

    return (
        <>
            <Input {...props} />
            {validation && !validation.valid && <div className={getClassByValidationLevel()}>
                {validation.message}
            </div>}
        </>
    )
}